import type { RouteLocationNormalizedLoaded } from "vue-router"

export const MEDIA_LIBRARY_DETAIL_PAGE_ROUTE_NAMES = ["file-general", "file-usage", "file-comments", "file-video-analytics", "folder-general"] as const
export type MediaLibraryDetailPageRouteName = (typeof MEDIA_LIBRARY_DETAIL_PAGE_ROUTE_NAMES)[number]

export function getMediaLibraryDetailRouteName(route: RouteLocationNormalizedLoaded, detailPageRouteName: MediaLibraryDetailPageRouteName): string {
  const routeNamespace = route.meta.mediaLibraryDetailRouteNamespace

  if (typeof routeNamespace !== "string") {
    throw new Error("Could not determine the media-library detail route namespace.")
  }

  return `${routeNamespace}/${detailPageRouteName}`
}

export function getMediaLibraryFileDetailPageRoutes(detailRouteNamespace: string, routePrefix = "") {
  return [
    {
      path: routePrefix ? routePrefix : "",
      name: `${detailRouteNamespace}-files/outlet`,
      component: () => import("./components/files/MediaLibraryFileDetailWrapper.vue"),
      meta: {
        isDetailPageOutlet: true,
      },
      children: [
        {
          path: `:fileId/general`,
          name: `${detailRouteNamespace}/file-general`,
          component: () => import("./views/files/MediaLibraryFileEditGeneral.vue"),
          meta: {
            isDetailPage: true,
            module: "media-library",
          },
        },
        {
          path: `:fileId/usage`,
          name: `${detailRouteNamespace}/file-usage`,
          component: () => import("./views/files/MediaLibraryFileUsage.vue"),
          meta: {
            isDetailPage: true,
            module: "media-library",
          },
        },
        {
          path: `:fileId/comments`,
          name: `${detailRouteNamespace}/file-comments`,
          component: () => import("./views/files/MediaLibraryFileEditComments.vue"),
          meta: {
            isDetailPage: true,
            module: "media-library",
          },
        },
        {
          path: `:fileId/video-analytics`,
          name: `${detailRouteNamespace}/file-video-analytics`,
          component: () => import("./views/files/MediaLibraryVideoFileAnalytics.vue"),
          meta: {
            isDetailPage: true,
            module: "media-library",
          },
        },
      ],
    },
  ]
}

export function getMediaLibraryFolderDetailPageRoutes(detailRouteNamespace: string, routePrefix = "") {
  return [
    {
      path: routePrefix ? routePrefix : "",
      name: `${detailRouteNamespace}-folders/outlet`,
      component: () => import("./components/folders/MediaLibraryFolderDetailWrapper.vue"),
      meta: {
        isDetailPageOutlet: true,
      },
      children: [
        {
          path: `:itemId/general`,
          name: `${detailRouteNamespace}/folder-general`,
          component: () => import("./views/folders/MediaLibraryFolderEditGeneral.vue"),
          meta: {
            isDetailPage: true,
            module: "media-library",
          },
        },
      ],
    },
  ]
}

export function getMediaLibrariesRoutes() {
  return [
    {
      /* named it  learningmaterials because of the old backend*/
      path: "/learningmaterials",
      name: "learningmaterials",
      component: () => import("./components/MediaLibrariesOld.vue"),
    },
    {
      path: "/media-library/:folderId?",
      name: "media-library-folder-content",
      component: () => import("./views/MediaLibrary.vue"),
      meta: {
        isDetailPageOutlet: true,
        module: "media-library",
        mediaLibraryDetailRouteNamespace: "media-library",
      },
      children: [...getMediaLibraryFolderDetailPageRoutes("media-library", "details"), ...getMediaLibraryFileDetailPageRoutes("media-library", "files/details")],
    },
  ]
}
